import UserList from './UserList';
import UserEdit from './UserEdit';
import UserShow from './UserShow';

export default {
    list: UserList,
    edit: UserEdit,
    show:UserShow,
};